module.exports = __webpack_public_path__ + "92b97a290b8908d1eb5b29411064e988.woff";


//////////////////
// WEBPACK FOOTER
// ../shared/css/rover_icons/fonts/rover-icons.woff?f8o35m
// module id = 2298
// module chunks = 70